module.exports = __webpack_public_path__ + "img/20180815_145911_029.9f7c3452.jpg";